var _rect, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupersetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#0C1238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_1073)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.68657,
    y: 8.59702,
    width: 72,
    height: 72,
    fill: "#2C335C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2045 24.3831L19.4285 25.5164L20.3806 26.4458L19.5192 27.8512L18.9979 26.3324L18.1138 24.791L18.2045 24.3831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6751 26.7403L19.7913 28.123L20.1311 29.9815L20.7431 28.7576L20.6751 26.7403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8722 24.3831L22.6483 25.5164L21.6965 26.4458L22.5576 27.8512L23.0788 26.3324L23.9629 24.791L23.8722 24.3831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4017 26.7403L22.2858 28.123L21.9456 29.9815L21.3336 28.7576L21.4017 26.7403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3208 23.6578L17.0487 30.0269L18.4313 36.2826L18.1819 36.2599L16.5728 30.5935L16.7768 23.2953L17.3208 23.6578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5245 26.2644L19.5645 30.8656L19.0886 36.464H18.8392L17.3888 29.8228L17.5245 26.2644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.859 31.3642L19.3605 36.4186L20.1312 36.9172L20.7658 34.5827L20.0631 31.7721L19.859 31.3642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7563 23.6578L25.0281 30.0269L23.6454 36.2826L23.8949 36.2599L25.504 30.5935L25.3002 23.2953L24.7563 23.6578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5522 26.2644L22.5122 30.8656L22.9884 36.464H23.2376L24.6883 29.8228L24.5522 26.2644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2177 31.3642L22.7163 36.4186L21.9456 36.9172L21.3109 34.5827L22.0136 31.7721L22.2177 31.3642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6606 24.3831L19.8817 29.3469L20.2445 31.7494L17.6379 25.8792L17.6606 24.3831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4162 24.3831L22.1951 29.3469L21.8323 31.7494L24.4389 25.8792L24.4162 24.3831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6228 37.076L23.6908 37.6879L23.2149 38.2772L23.0562 39.2063L22.739 39.3424L22.4669 37.9371L22.2858 37.4385L22.4442 37.1213L23.6228 37.076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5151 37.1213L21.8549 38.0731L22.5803 39.4785L22.3988 40.7704L21.8776 39.3197L21.447 38.5037L21.5151 37.1213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3935 36.3279L23.5547 38.6397L24.0536 38.436L24.4615 38.3906L24.3935 36.3279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.454 37.076L18.3859 37.6879L18.8618 38.2772L19.0206 39.2063L19.3377 39.3424L19.6099 37.9371L19.7913 37.4385L19.6325 37.1213L18.454 37.076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5617 37.1213L20.2218 38.0731L19.4965 39.4785L19.6779 40.7704L20.1992 39.3197L20.6297 38.5037L20.5617 37.1213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6833 36.3279L18.522 38.6397L18.0235 38.436L17.6153 38.3906L17.6833 36.3279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9299 15.929L18.6805 16.3369L18.7712 17.1983L19.859 16.541L20.539 16.4729L20.6297 15.3397L18.9299 15.929Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8392 17.6969L18.8165 18.7621L19.4285 18.4676L20.5617 18.3769L20.6071 16.9489L18.8392 17.6969Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8165 19.2606L18.7711 20.3261L19.4965 20.3488L20.5844 20.8474L20.6524 19.0795L18.8165 19.2606Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9526 20.9608L19.5872 24.9724L20.5844 25.6524L20.6977 22.1847L20.4259 21.1646L18.9526 20.9608Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1469 15.929L23.3963 16.3369L23.3056 17.1983L22.2177 16.541L21.5377 16.4729L21.447 15.3397L23.1469 15.929Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2376 17.6969L23.2603 18.7621L22.6483 18.4676L21.5151 18.3769L21.4697 16.9489L23.2376 17.6969Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2602 19.2606L23.3056 20.3261L22.5802 20.3488L21.4924 20.8474L21.4243 19.0795L23.2602 19.2606Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1242 20.9608L22.4896 24.9724L21.4924 25.6524L21.379 22.1847L21.6511 21.1646L23.1242 20.9608Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3633 20.0767L18.4314 22.6153L18.7939 23.5444L18.6581 23.9072L17.0714 22.6606L17.2528 19.3287L18.3633 20.0767Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7135 20.0767L23.6454 22.6153L23.2829 23.5444L23.419 23.9072L25.0054 22.6606L24.824 19.3287L23.7135 20.0767Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7995 14.3423L17.4568 14.9089L17.0033 15.113L16.6635 14.9996L16.7995 14.3423Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7286 14.9089L17.4115 15.181L18.3179 15.5662L18.4994 15.3624L17.7286 14.9089Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3208 15.3397L18.3633 15.997L18.1592 16.7674L17.3662 15.861L17.2528 15.4304L17.3208 15.3397Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6861 15.2037L17.0033 15.4755L17.3888 16.2689L16.5501 15.9971L16.6861 15.2037Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7995 16.4049L18.0008 17.946L18.1139 16.9262L17.1621 16.3823L16.7995 16.4049Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6181 16.473L17.4568 17.8556L18.0458 18.5356L17.9781 19.374L17.706 19.2833L16.8449 18.3542L16.5501 16.9715L16.6181 16.473Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2776 14.3423L24.6203 14.9089L25.0735 15.113L25.4133 14.9996L25.2776 14.3423Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3481 14.9089L24.6656 15.181L23.7588 15.5662L23.5774 15.3624L24.3481 14.9089Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7563 15.3397L23.7135 15.997L23.9175 16.7674L24.7109 15.861L24.824 15.4304L24.7563 15.3397Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3906 15.2037L25.0735 15.4755L24.6883 16.2689L25.5267 15.9971L25.3906 15.2037Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2776 16.4049L24.0763 17.946L23.9629 16.9262L24.9147 16.3823L25.2776 16.4049Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4587 16.473L24.6202 17.8556L24.0309 18.5356L24.099 19.374L24.3708 19.2833L25.2322 18.3542L25.5267 16.9715L25.4587 16.473Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1248 10.7161L17.1785 12.6412L20.6732 13.1693L20.5847 11.241L18.7341 10.6531L18.1248 10.7161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9833 10.7161L24.9296 12.6412L21.4349 13.1693L21.5234 11.241L23.374 10.6531L23.9833 10.7161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0542 12.8742L16.2102 13.5265L18.5447 14.9315L20.7204 14.569L20.6732 13.4644L17.0542 12.8742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0539 12.8742L25.8979 13.5265L23.5634 14.9315L21.3877 14.569L21.4349 13.4644L25.0539 12.8742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9211 20.2808L11.541 24.4512L11.9038 25.3353L14.4877 21.958L15.5302 19.2607L13.9211 20.2808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.513 18.1274L13.649 20.0994L10.7933 24.7687L10.5892 24.6553L11.9945 22.026L12.1756 20.666L12.8556 18.7621L13.513 18.1274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.156 20.2808L30.5358 24.4512L30.173 25.3353L27.5894 21.958L26.5468 19.2607L28.156 20.2808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5639 18.1274L28.4278 20.0994L31.2838 24.7687L31.4876 24.6553L30.0823 22.026L29.9012 20.666L29.2212 18.7621L28.5639 18.1274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0569 17.0849L14.2836 18.3996L15.3035 17.6969L16.1195 16.0651L16.3913 14.2969L15.7794 13.8437L14.7822 14.2289L14.0569 17.0849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3063 14.5917L13.8304 16.8808L14.1475 18.7394L13.3995 17.6062L13.3768 15.9063L14.3063 14.5917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0199 17.0849L27.7931 18.3996L26.7733 17.6969L25.9572 16.0651L25.6854 14.2969L26.2974 13.8437L27.2945 14.2289L28.0199 17.0849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7705 14.5917L28.2467 16.8808L27.9292 18.7394L28.6772 17.6062L28.6999 15.9063L27.7705 14.5917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9888 19.4421L15.5756 17.7876L15.3715 18.8528L14.1022 19.7596L13.9888 19.4421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0879 19.4421L26.5014 17.7876L26.7052 18.8528L27.9745 19.7596L28.0879 19.4421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5727 10.7158L15.1674 11.9171L14.3743 13.7756L14.329 12.0531L15.3942 10.6478L16.5727 10.7158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.504 10.7158L26.9093 11.9171L27.7027 13.7756L27.7478 12.0531L26.6826 10.6478L25.504 10.7158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8672 10.7838L15.5075 11.9851L14.7822 13.7983L16.6408 12.8465L17.6833 10.7612L16.8672 10.7838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2095 10.7838L26.5692 11.9851L27.2945 13.7983L25.436 12.8465L24.3935 10.7612L25.2095 10.7838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4547 24.8705L10.7491 25.5732L11.6106 25.7092L11.6786 26.9785L11.2254 28.7917L10.9306 28.7691L11.2167 27.5619L10.9107 27.5535L10.432 28.8371L10.0695 28.7917L10.5199 27.4939L10.2052 27.4346L9.59325 28.8144L9.14002 28.7691L9.76348 27.3327L9.54789 27.205L8.7775 28.4289L8.39199 28.3836L9.54789 26.1851L9.43482 26.0037L8.34664 26.457L8.27861 26.2078L9.1627 25.4144L10.4547 24.8705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5755 24.8705L31.281 25.5732L30.4196 25.7092L30.3516 26.9785L30.8051 28.7917L31.0996 28.7691L30.8135 27.5619L31.1195 27.5535L31.5982 28.8371L31.961 28.7917L31.5103 27.4939L31.825 27.4346L32.4369 28.8144L32.8901 28.7691L32.2667 27.3327L32.4823 27.205L33.2527 28.4289L33.6382 28.3836L32.4823 26.1851L32.5957 26.0037L33.6835 26.457L33.7512 26.2078L32.8675 25.4144L31.5755 24.8705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3604 9.06134L19.9497 10.1265H17.3888L19.3604 9.06134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7163 9.06134L22.127 10.1265H24.6883L22.7163 9.06134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4058 7.33884L20.4259 8.8119L20.6977 10.9199L19.6099 9.08402L19.4058 7.33884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.671 7.33884L21.6512 8.8119L21.379 10.9199L22.4669 9.08402L22.671 7.33884Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6_1073)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.3433,
    y: 26.7463,
    width: 72,
    height: 72,
    fill: "#2C335C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4058 37.7966L44.2626 38.5898L44.9291 39.2404L44.3261 40.2242L43.9612 39.1611L43.3423 38.0821L43.4058 37.7966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1352 39.4466L44.5166 40.4144L44.7545 41.7154L45.1828 40.8587L45.1352 39.4466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3732 37.7966L46.5165 38.5898L45.8502 39.2404L46.453 40.2242L46.8178 39.1611L47.4367 38.0821L47.3732 37.7966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6438 39.4466L46.2627 40.4144L46.0246 41.7154L45.5962 40.8587L45.6438 39.4466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7872 37.2888L42.5967 41.7472L43.5646 46.1262L43.39 46.1103L42.2636 42.1438L42.4065 37.035L42.7872 37.2888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9298 39.1134L44.3578 42.3343L44.0247 46.2531H43.8501L42.8348 41.6043L42.9298 39.1134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.564 42.6833L44.215 46.2214L44.7545 46.5704L45.1987 44.9363L44.7069 42.9688L44.564 42.6833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9921 37.2888L48.1823 41.7472L47.2145 46.1262L47.3891 46.1103L48.5155 42.1438L48.3728 37.035L47.9921 37.2888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8492 39.1134L46.4212 42.3343L46.7546 46.2531H46.9289L47.9444 41.6043L47.8492 39.1134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2151 42.6833L46.5641 46.2214L46.0246 46.5704L45.5803 44.9363L46.0722 42.9688L46.2151 42.6833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0251 37.7966L44.5799 41.2712L44.8338 42.9529L43.0092 38.8438L43.0251 37.7966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.754 37.7966L46.1992 41.2712L45.9453 42.9529L47.7699 38.8438L47.754 37.7966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1986 46.6815L47.2462 47.1099L46.9131 47.5224L46.802 48.1728L46.58 48.268L46.3895 47.2843L46.2627 46.9353L46.3736 46.7133L47.1986 46.6815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7232 46.7133L45.9611 47.3795L46.4689 48.3633L46.3419 49.2676L45.977 48.2521L45.6756 47.6809L45.7232 46.7133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7381 46.1579L47.151 47.7762L47.5002 47.6335L47.7857 47.6018L47.7381 46.1579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5804 46.6815L43.5328 47.1099L43.866 47.5224L43.9771 48.1728L44.1991 48.268L44.3896 47.2843L44.5166 46.9353L44.4054 46.7133L43.5804 46.6815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0558 46.7133L44.818 47.3795L44.3102 48.3633L44.4372 49.2676L44.8021 48.2521L45.1035 47.6809L45.0558 46.7133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.041 46.1579L43.6281 47.7762L43.2791 47.6335L42.9934 47.6018L43.041 46.1579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9136 31.8787L43.739 32.1642L43.8025 32.7672L44.564 32.3071L45.04 32.2594L45.1035 31.4662L43.9136 31.8787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8501 33.1162L43.8342 33.8618L44.2626 33.6557L45.0559 33.5922L45.0876 32.5926L43.8501 33.1162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8342 34.2108L43.8025 34.9567L44.3102 34.9725L45.0717 35.3215L45.1193 34.084L43.8342 34.2108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9295 35.4009L44.3737 38.2091L45.0717 38.6851L45.1511 36.2577L44.9608 35.5436L43.9295 35.4009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8655 31.8787L47.0401 32.1642L46.9766 32.7672L46.2151 32.3071L45.7391 32.2594L45.6756 31.4662L46.8655 31.8787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.929 33.1162L46.9449 33.8618L46.5165 33.6557L45.7232 33.5922L45.6915 32.5926L46.929 33.1162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9448 34.2108L46.9766 34.9567L46.4688 34.9725L45.7073 35.3215L45.6597 34.084L46.9448 34.2108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8496 35.4009L46.4054 38.2091L45.7074 38.6851L45.628 36.2577L45.8185 35.5436L46.8496 35.4009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.517 34.7821L43.5646 36.5591L43.8184 37.2095L43.7233 37.4634L42.6126 36.5908L42.7396 34.2585L43.517 34.7821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2621 34.7821L47.2145 36.5591L46.9607 37.2095L47.056 37.4634L48.1665 36.5908L48.0395 34.2585L47.2621 34.7821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4223 30.7679L42.8825 31.1646L42.565 31.3074L42.3271 31.2281L42.4223 30.7679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0727 31.1646L42.8507 31.3551L43.4852 31.6247L43.6122 31.4821L43.0727 31.1646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7872 31.4662L43.517 31.9263L43.3741 32.4656L42.819 31.8311L42.7396 31.5297L42.7872 31.4662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.343 31.3709L42.565 31.5612L42.8348 32.1166L42.2477 31.9263L42.343 31.3709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4223 32.2118L43.2632 33.2906L43.3424 32.5767L42.6761 32.196L42.4223 32.2118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2953 32.2594L42.8824 33.2273L43.2947 33.7033L43.2473 34.2902L43.0568 34.2267L42.4541 33.5763L42.2477 32.6084L42.2953 32.2594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.357 30.7679L47.8969 31.1646L48.2141 31.3074L48.452 31.2281L48.357 30.7679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7064 31.1646L47.9286 31.3551L47.2939 31.6247L47.1669 31.4821L47.7064 31.1646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9921 31.4662L47.2621 31.9263L47.4049 32.4656L47.9603 31.8311L48.0395 31.5297L47.9921 31.4662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4361 31.3709L48.2141 31.5612L47.9445 32.1166L48.5314 31.9263L48.4361 31.3709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.357 32.2118L47.5161 33.2906L47.4367 32.5767L48.103 32.196L48.357 32.2118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4837 32.2594L47.8968 33.2273L47.4843 33.7033L47.532 34.2902L47.7222 34.2267L48.3252 33.5763L48.5313 32.6084L48.4837 32.2594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.35 28.2296L42.6876 29.5772L45.1339 29.9469L45.072 28.5971L43.7766 28.1855L43.35 28.2296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.451 28.2296L48.1134 29.5772L45.6671 29.9469L45.729 28.5971L47.0245 28.1855L47.451 28.2296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6007 29.7403L42.0098 30.1969L43.644 31.1804L45.167 30.9267L45.1339 30.1534L42.6007 29.7403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2004 29.7403L48.7912 30.1969L47.1571 31.1804L45.6341 30.9267L45.6671 30.1534L48.2004 29.7403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4074 34.9249L38.7413 37.8442L38.9953 38.463L40.8041 36.0989L41.5338 34.2108L40.4074 34.9249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1217 33.4176L40.217 34.7979L38.218 38.0664L38.0751 37.9871L39.0588 36.1466L39.1856 35.1946L39.6616 33.8618L40.1217 33.4176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3718 34.9249L52.0377 37.8442L51.7837 38.463L49.9752 36.0989L49.2455 34.2108L50.3718 34.9249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6574 33.4176L50.5621 34.7979L52.5614 38.0664L52.704 37.9871L51.7203 36.1466L51.5935 35.1946L51.1175 33.8618L50.6574 33.4176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5025 32.6878L40.6612 33.6081L41.3751 33.1162L41.9463 31.9739L42.1366 30.7362L41.7082 30.4189L41.0102 30.6886L40.5025 32.6878Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6771 30.9426L40.3439 32.5449L40.566 33.8459L40.0423 33.0527L40.0265 31.8628L40.6771 30.9426Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2766 32.6878L50.1179 33.6081L49.404 33.1162L48.8327 31.9739L48.6425 30.7362L49.0708 30.4189L49.7689 30.6886L50.2766 32.6878Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.102 30.9426L50.4354 32.5449L50.2131 33.8459L50.7367 33.0527L50.7526 31.8628L50.102 30.9426Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4549 34.3378L41.5656 33.1797L41.4227 33.9253L40.5342 34.5601L40.4549 34.3378Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3242 34.3378L49.2137 33.1797L49.3563 33.9253L50.2448 34.5601L50.3242 34.3378Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2636 28.2294L41.2798 29.0703L40.7247 30.3713L40.6929 29.1656L41.4386 28.1818L42.2636 28.2294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5155 28.2294L49.4992 29.0703L50.0546 30.3713L50.0861 29.1656L49.3405 28.1818L48.5155 28.2294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4697 28.2771L41.518 29.118L41.0102 30.3872L42.3112 29.7209L43.041 28.2612L42.4697 28.2771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3093 28.2771L49.2611 29.118L49.7689 30.3872L48.4679 29.7209L47.7381 28.2612L48.3093 28.2771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9809 38.1377L38.1871 38.6296L38.7901 38.7248L38.8377 39.6133L38.5204 40.8826L38.3141 40.8667L38.5143 40.0217L38.3001 40.0158L37.9651 40.9143L37.7113 40.8826L38.0266 39.9741L37.8063 39.9326L37.3779 40.8985L37.0607 40.8667L37.4971 39.8612L37.3462 39.7719L36.8069 40.6286L36.5371 40.5969L37.3462 39.058L37.267 38.931L36.5053 39.2482L36.4577 39.0738L37.0766 38.5185L37.9809 38.1377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7655 38.1377L52.5594 38.6296L51.9564 38.7248L51.9088 39.6133L52.2263 40.8826L52.4324 40.8667L52.2321 40.0217L52.4463 40.0158L52.7814 40.9143L53.0354 40.8826L52.7199 39.9741L52.9402 39.9326L53.3685 40.8985L53.6858 40.8667L53.2494 39.8612L53.4003 39.7719L53.9395 40.6286L54.2094 40.5969L53.4003 39.058L53.4796 38.931L54.2411 39.2482L54.2885 39.0738L53.6699 38.5185L52.7655 38.1377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.215 27.0713L44.6275 27.8169H42.8348L44.215 27.0713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5641 27.0713L46.1516 27.8169H47.9445L46.5641 27.0713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2467 25.8655L44.9608 26.8967L45.1511 28.3723L44.3896 27.0872L44.2467 25.8655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5324 25.8655L45.8185 26.8967L45.628 28.3723L46.3895 27.0872L46.5324 25.8655Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6_1073)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.9702,
    y: 40.1194,
    width: 72,
    height: 72,
    fill: "#2C335C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5773 46.4338L27.0669 46.8871L27.4477 47.2589L27.1032 47.821L26.8947 47.2135L26.541 46.597L26.5773 46.4338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5655 47.3767L27.212 47.9298L27.348 48.6732L27.5928 48.1836L27.5655 47.3767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8444 46.4338L28.3548 46.8871L27.9741 47.2589L28.3185 47.821L28.527 47.2135L28.8807 46.597L28.8444 46.4338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8562 47.3767L28.2098 47.9298L28.0738 48.6732L27.829 48.1836L27.8562 47.3767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2238 46.1437L26.115 48.6913L26.668 51.1936L26.5683 51.1845L25.9246 48.918L26.0063 45.9987L26.2238 46.1437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3053 47.1863L27.1213 49.0268L26.931 51.2662H26.8312L26.251 48.6097L26.3053 47.1863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2391 49.2263L27.0397 51.248L27.348 51.4475L27.6018 50.5137L27.3208 49.3894L27.2391 49.2263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.198 46.1437L29.3068 48.6913L28.7537 51.1936L28.8535 51.1845L29.4971 48.918L29.4156 45.9987L29.198 46.1437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1164 47.1863L28.3004 49.0268L28.4909 51.2662H28.5905L29.1708 48.6097L29.1164 47.1863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1826 49.2263L28.382 51.248L28.0738 51.4475L27.8199 50.5137L28.101 49.3894L28.1826 49.2263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3598 46.4338L27.2482 48.4193L27.3933 49.3803L26.3507 47.0323L26.3598 46.4338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.062 46.4338L28.1736 48.4193L28.0284 49.3803L29.0711 47.0323L29.062 46.4338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7446 51.511L28.7718 51.7558L28.5815 51.9915L28.518 52.3631L28.3911 52.4176L28.2823 51.8554L28.2098 51.656L28.2732 51.5291L28.7446 51.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9016 51.5291L28.0375 51.9098L28.3276 52.472L28.2551 52.9888L28.0466 52.4085L27.8743 52.0821L27.9016 51.5291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0529 51.2118L28.7174 52.1365L28.917 52.055L29.0801 52.0368L29.0529 51.2118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6771 51.511L26.6499 51.7558L26.8403 51.9915L26.9038 52.3631L27.0306 52.4176L27.1395 51.8554L27.212 51.656L27.1485 51.5291L26.6771 51.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5202 51.5291L27.3843 51.9098L27.0941 52.472L27.1667 52.9888L27.3752 52.4085L27.5474 52.0821L27.5202 51.5291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3689 51.2118L26.7043 52.1365L26.5049 52.055L26.3416 52.0368L26.3689 51.2118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8675 43.0522L26.7677 43.2153L26.804 43.5599L27.2391 43.297L27.5111 43.2698L27.5474 42.8165L26.8675 43.0522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8312 43.7593L26.8221 44.1854L27.0669 44.0676L27.5202 44.0313L27.5383 43.4601L26.8312 43.7593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8221 44.3848L26.804 44.811L27.0941 44.8201L27.5293 45.0195L27.5565 44.3124L26.8221 44.3848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8765 45.0649L27.1304 46.6695L27.5293 46.9415L27.5746 45.5545L27.4659 45.1464L26.8765 45.0649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5543 43.0522L28.654 43.2153L28.6178 43.5599L28.1826 43.297L27.9106 43.2698L27.8743 42.8165L28.5543 43.0522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5906 43.7593L28.5996 44.1854L28.3548 44.0676L27.9016 44.0313L27.8834 43.4601L28.5906 43.7593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5996 44.3848L28.6177 44.811L28.3276 44.8201L27.8925 45.0195L27.8652 44.3124L28.5996 44.3848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5452 45.0649L28.2914 46.6695L27.8925 46.9415L27.8471 45.5545L27.956 45.1464L28.5452 45.0649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6408 44.7113L26.6681 45.7267L26.8131 46.0983L26.7588 46.2435L26.1241 45.7448L26.1966 44.412L26.6408 44.7113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7809 44.7113L28.7537 45.7267L28.6087 46.0983L28.6631 46.2435L29.2977 45.7448L29.2251 44.412L28.7809 44.7113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0153 42.4175L26.2783 42.6441L26.0968 42.7258L25.9609 42.6804L26.0153 42.4175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.387 42.6441L26.2601 42.753L26.6227 42.9071L26.6953 42.8256L26.387 42.6441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2238 42.8165L26.6408 43.0794L26.5592 43.3875L26.242 43.025L26.1966 42.8527L26.2238 42.8165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.97 42.7621L26.0968 42.8708L26.251 43.1881L25.9155 43.0794L25.97 42.7621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0153 43.2426L26.4958 43.859L26.5411 43.4511L26.1603 43.2335L26.0153 43.2426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9428 43.2698L26.2782 43.8228L26.5138 44.0948L26.4868 44.4302L26.3779 44.3939L26.0335 44.0223L25.9155 43.4692L25.9428 43.2698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4065 42.4175L29.1436 42.6441L29.3249 42.7258L29.4608 42.6804L29.4065 42.4175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0348 42.6441L29.1618 42.753L28.7991 42.9071L28.7265 42.8256L29.0348 42.6441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.198 42.8165L28.7809 43.0794L28.8625 43.3875L29.1799 43.025L29.2251 42.8527L29.198 42.8165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4518 42.7621L29.3249 42.8708L29.1708 43.1881L29.5062 43.0794L29.4518 42.7621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4065 43.2426L28.926 43.859L28.8807 43.4511L29.2614 43.2335L29.4065 43.2426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.479 43.2698L29.1436 43.8228L28.9079 44.0948L28.9351 44.4302L29.0438 44.3939L29.3884 44.0223L29.5062 43.4692L29.479 43.2698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5454 40.967L26.1669 41.7371L27.5648 41.9483L27.5294 41.177L26.7892 40.9418L26.5454 40.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8888 40.967L29.2674 41.7371L27.8695 41.9483L27.9049 41.177L28.6451 40.9418L28.8888 40.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1172 41.8303L25.7796 42.0912L26.7134 42.6532L27.5837 42.5082L27.5648 42.0663L26.1172 41.8303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3171 41.8303L29.6547 42.0912L28.7209 42.6532L27.8506 42.5082L27.8695 42.0663L29.3171 41.8303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.864 44.7929L23.9119 46.4611L24.057 46.8147L25.0906 45.4638L25.5076 44.3849L24.864 44.7929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7007 43.9316L24.7551 44.7204L23.6128 46.5881L23.5312 46.5427L24.0933 45.491L24.1658 44.947L24.4378 44.1854L24.7007 43.9316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5579 44.7929L31.5098 46.4611L31.3647 46.8147L30.3313 45.4638L29.9142 44.3849L30.5579 44.7929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7211 43.9316L30.6666 44.7204L31.809 46.5881L31.8906 46.5427L31.3284 45.491L31.256 44.947L30.984 44.1854L30.7211 43.9316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9182 43.5146L25.009 44.0404L25.4169 43.7594L25.7433 43.1066L25.852 42.3994L25.6072 42.2181L25.2084 42.3722L24.9182 43.5146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.018 42.5173L24.8277 43.4329L24.9545 44.1763L24.6553 43.7231L24.6462 43.0431L25.018 42.5173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5035 43.5146L30.4128 44.0404L30.0048 43.7594L29.6784 43.1066L29.5697 42.3994L29.8145 42.2181L30.2133 42.3722L30.5035 43.5146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4037 42.5173L30.5942 43.4329L30.4672 44.1763L30.7664 43.7231L30.7755 43.0431L30.4037 42.5173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.891 44.4574L25.5257 43.7957L25.4441 44.2217L24.9364 44.5844L24.891 44.4574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5307 44.4574L29.8961 43.7957L29.9776 44.2217L30.4853 44.5844L30.5307 44.4574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9246 40.9669L25.3625 41.4474L25.0452 42.1908L25.0271 41.5018L25.4532 40.9397L25.9246 40.9669Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4971 40.9669L30.0593 41.4474L30.3766 42.1908L30.3946 41.5018L29.9685 40.9397L29.4971 40.9669Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0424 40.9941L25.4985 41.4746L25.2084 42.1999L25.9518 41.8192L26.3688 40.985L26.0424 40.9941Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3793 40.9941L29.9232 41.4746L30.2133 42.1999L29.4699 41.8192L29.0529 40.985L29.3793 40.9941Z",
    fill: "#FF1400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4774 46.6288L23.5952 46.9099L23.9397 46.9643L23.967 47.472L23.7857 48.1973L23.6677 48.1882L23.7822 47.7054L23.6598 47.702L23.4683 48.2155L23.3233 48.1973L23.5035 47.6782L23.3776 47.6544L23.1328 48.2064L22.9515 48.1882L23.2009 47.6137L23.1147 47.5626L22.8065 48.0522L22.6523 48.034L23.1147 47.1547L23.0694 47.0821L22.6342 47.2634L22.607 47.1637L22.9606 46.8464L23.4774 46.6288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9257 46.6288L31.8079 46.9099L31.4634 46.9643L31.4362 47.472L31.6176 48.1973L31.7354 48.1882L31.6209 47.7054L31.7433 47.702L31.9348 48.2155L32.0799 48.1973L31.8996 47.6782L32.0255 47.6544L32.2703 48.2064L32.4516 48.1882L32.2022 47.6137L32.2884 47.5626L32.5966 48.0522L32.7508 48.034L32.2884 47.1547L32.3338 47.0821L32.7689 47.2634L32.796 47.1637L32.4425 46.8464L31.9257 46.6288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0397 40.3051L27.2754 40.7312H26.251L27.0397 40.3051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.382 40.3051L28.1463 40.7312H29.1708L28.382 40.3051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0578 39.6161L27.4659 40.2053L27.5746 41.0486L27.1395 40.3142L27.0578 39.6161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3639 39.6161L27.956 40.2053L27.8471 41.0486L28.2823 40.3142L28.3639 39.6161Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_1073"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.68657 22.9254C6.68657 15.012 13.1016 8.59702 21.0149 8.59702V8.59702C28.9283 8.59702 35.3433 15.012 35.3433 22.9254V22.9254C35.3433 30.8387 28.9283 37.2537 21.0149 37.2537V37.2537C13.1016 37.2537 6.68657 30.8387 6.68657 22.9254V22.9254Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6_1073"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3433 36.7761C35.3433 31.2368 39.8338 26.7463 45.3731 26.7463V26.7463C50.9125 26.7463 55.403 31.2368 55.403 36.7761V36.7761C55.403 42.3155 50.9125 46.806 45.3731 46.806V46.806C39.8338 46.806 35.3433 42.3155 35.3433 36.7761V36.7761Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6_1073"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9702 45.8508C21.9702 42.6854 24.5362 40.1194 27.7015 40.1194V40.1194C30.8668 40.1194 33.4328 42.6854 33.4328 45.8508V45.8508C33.4328 49.0161 30.8668 51.5821 27.7015 51.5821V51.5821C24.5362 51.5821 21.9702 49.0161 21.9702 45.8508V45.8508Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupersetIcon);
export default __webpack_public_path__ + "static/media/SupersetIcon.40a14eaca8fcb50ca122523f326beb65.svg";
export { ForwardRef as ReactComponent };